import React, { useState } from "react";
import { api } from "../../lib/api";
import { useFetch, act } from "../../lib/useFetch";
import { fmtDateTime } from "../../lib/format";
import { RefreshCw } from "lucide-react";

function RateCard({ label, value, sub, testid }) {
  return (
    <div className="glass-cyan rounded-xl p-4" data-testid={testid}>
      <div className="text-xs text-gray-400 uppercase tracking-widest">{label}</div>
      <div className="font-heading text-3xl font-bold text-gold mt-1">{value}</div>
      <div className="text-xs text-gray-400 mt-1">{sub}</div>
    </div>
  );
}

export default function RatesPanel() {
  const [rates, reloadRates] = useFetch("/rates");
  const [hist, reloadHist] = useFetch("/admin/rates/history");
  const [busy, setBusy] = useState(false);

  const refresh = async () => {
    setBusy(true);
    await act(api.post("/admin/rates/refresh"), "Курсы обновлены");
    setBusy(false);
    reloadRates();
    reloadHist();
  };

  return (
    <div className="glass rounded-2xl p-6" data-testid="panel-rates">
      <div className="flex items-center justify-between flex-wrap gap-3 mb-4">
        <h3 className="font-heading text-2xl font-bold">💱 Курсы валют</h3>
        <button onClick={refresh} disabled={busy} className="btn-outline !py-2 inline-flex items-center gap-2 text-sm" data-testid="rates-refresh-btn">
          <RefreshCw size={14} className={busy ? "animate-spin" : ""} /> Обновить сейчас
        </button>
      </div>
      {rates && (
        <div className="grid sm:grid-cols-3 gap-4">
          <RateCard label="1 ₽ → $" value={rates.RUB_USD.toFixed(4)} sub={`1 $ = ${(1 / rates.RUB_USD).toFixed(2)} ₽`} testid="rate-usd" />
          <RateCard label="1 ₽ → ¥" value={rates.RUB_CNY.toFixed(4)} sub={`1 ¥ = ${(1 / rates.RUB_CNY).toFixed(2)} ₽`} testid="rate-cny" />
          <div className="glass-cyan rounded-xl p-4">
            <div className="text-xs text-gray-400 uppercase tracking-widest">Источник</div>
            <div className="text-lg mt-1" data-testid="rate-source">{rates.source}</div>
            <div className="text-xs text-gray-400 mt-1" data-testid="rate-updated">Обновлено: {fmtDateTime(rates.updated_at)}</div>
            {rates.stale && <div className="text-xs text-red-400 mt-1">Источники недоступны — показаны последние сохранённые курсы</div>}
          </div>
        </div>
      )}
      <p className="text-xs text-gray-500 mt-3">Базовая валюта — ₽. Курсы обновляются автоматически раз в час: ЦБ РФ, при недоступности — open.er-api.com.</p>
      <div className="mt-6">
        <div className="text-xs tracking-widest uppercase text-gold mb-2">История обновлений</div>
        <div className="space-y-1 max-h-[320px] overflow-y-auto" data-testid="rates-history">
          {(hist?.history || []).map((h, i) => (
            <div key={i} className="flex gap-4 text-xs font-mono border-b border-white/5 py-1.5">
              <span className="text-gray-400 w-36">{fmtDateTime(h.updated_at)}</span>
              <span>$ {h.RUB_USD}</span><span>¥ {h.RUB_CNY}</span><span className="text-gray-500 ml-auto">{h.source}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
